import React from "react";
import { useTranslation } from "locales";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import FullWidthPageBackground from "components/FullWidthPageBackground";
import WWHTestimonialItem from "./components/WWHTestimonialItem";
import useViewController from "./viewController";
import "./style.scss";

export default function BlockWWHTestimonials() {
  const { t } = useTranslation();
  const { testimonial } = useViewController();

  return (
    <div className="block-wwh-testimonials">
      <FullWidthPageBackground className="block-measuring-success__background" />
      <div className="block-wwh-testimonials__content d-flex __column __align-center">
        <h2 className="block-wwh-testimonials__title h2 mb-4 text-center mx-auto">
          {t("Don't just take our word for it")}
        </h2>
        <div className="block-wwh-testimonials__description subtitle-1 mb-10 text-center mx-auto fw-semibold">
          {t("Hear from our students who transformed their potential into offers")}
        </div>

        {testimonial && <WWHTestimonialItem item={testimonial} />}

        <BaseButton
          className="block-wwh-testimonials__btn body-big fw-bold pl-4 pr-3 mt-10"
          to={"/coaches"}
          large
          borderless
        >
          {t("Find a Coach")}
          <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
        </BaseButton>
      </div>
    </div>
  );
}
